import {ChangeDetectorRef, Component, ElementRef, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractPasswordInput} from "../abstract-password-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterPasswordInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-password-input",
    styleUrls: ["./filter-password-input.component.scss"],
    templateUrl: "./filter-password-input.component.html",
    standalone: false
})
export class FUIFilterPasswordInputComponent extends FUIAbstractPasswordInput {

    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, changeDetectorRef);
    }

    /**
     * Perform events after a click on the host
     * @param element
     */
    @HostListener("click")
    override click(): void {
        this.focus();
    }
}
